export class TokenRequest {
    constructor(public username: string, public password: string) {

    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/models/tokenrequest.model.ts